import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, CopyToClipboardLink, Table, TableCell, TableBody, TableRow } from '@weezevent/nacre';

import { SauronEmptyCard } from 'components';

import { formatAttributes } from 'utils/utils';

import css from '../../emails.module.css';

export const InactiveDomains = ({ domain }) => {
    const { t } = useTranslation();

    const dnsRecords = React.useMemo(() => formatAttributes(domain.verification_attributes), [domain.verification_attributes]);

    return (
        <Card>
            {dnsRecords?.length > 0 ? (
                <Table>
                    <Table.THead>
                        <Table.Tr isHeader>
                            <TableCell className={css['domain-row']}>{t(`sauron.emails.domains.dns.name`)}</TableCell>
                            <TableCell className={css['domain-row']}>{t(`sauron.emails.domains.dns.type`)}</TableCell>
                            <TableCell className={css['domain-row']}>{t(`sauron.emails.domains.dns.value`)}</TableCell>
                        </Table.Tr>
                    </Table.THead>
                    {dnsRecords &&
                        dnsRecords.map((dnsRecords, index) => (
                            <TableBody key={index}>
                                <TableRow className={css['domains-table']}>
                                    <TableCell className={css['domain-row']}>
                                        <CopyToClipboardLink delay={1000} value={dnsRecords.name} copyOnIconClick>
                                            <span>{dnsRecords.name}</span>
                                        </CopyToClipboardLink>
                                    </TableCell>
                                    <TableCell className={css['domain-row']}>
                                        <CopyToClipboardLink delay={1000} value={dnsRecords.type} copyOnIconClick>
                                            <span>{dnsRecords.type}</span>
                                        </CopyToClipboardLink>
                                    </TableCell>
                                    <TableCell className={css['domain-row']}>
                                        <CopyToClipboardLink delay={1000} value={dnsRecords.value} copyOnIconClick>
                                            <span>{dnsRecords.value}</span>
                                        </CopyToClipboardLink>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        ))}
                </Table>
            ) : (
                <SauronEmptyCard subTitle={t('sauron.emails.domains.dns.no-dnsRecords')} />
            )}
        </Card>
    );
};
